if (!customElements.get('koko-get-ready')) {
 customElements.define('koko-get-ready',class extends HTMLElement {
  connectedCallback(){
   this.abort?.abort();
   this.abort=new AbortController(); const signal=this.abort.signal;
   const tabs=[...this.querySelectorAll('[role=tab]')],panels=[...this.querySelectorAll('[role=tabpanel]')],photos=[...this.querySelectorAll('[data-ready-photo]')];
   const reduced=matchMedia('(prefers-reduced-motion: reduce)');
   const mobile=matchMedia('(max-width: 767px)');
   const refined=this.classList.contains('koko-ready--refined');
   this.preload?.disconnect();
   if(refined){
    this.preload=new IntersectionObserver(entries=>{
     if(!entries.some(entry=>entry.isIntersecting))return;
     this.querySelectorAll('img').forEach(image=>{image.loading='eager';});
     this.preload.disconnect();
    },{rootMargin:'800px'});
    this.preload.observe(this);
   }
   let revision=0;
   const activate=index=>{
    const previous=Number(this.dataset.active);
    if(refined&&previous===index)return;
    this.dataset.active=index;
    const current=++revision;
    this.motion?.cancel();
    this.productMotion?.cancel();
    this.noteMotion?.cancel();
    this.slideMotions?.forEach(motion=>motion.cancel());
    tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',i===index);tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;photos[i].hidden=i!==index;panels[i].inert=i!==index;photos[i].inert=i!==index;panels[i].setAttribute('aria-hidden',i!==index);photos[i].setAttribute('aria-hidden',i!==index);});
    if(refined&&mobile.matches&&!reduced.matches){
     const outgoing=[photos[previous],panels[previous]];
     outgoing.forEach(element=>{element.hidden=false;});
     const timing={duration:460,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'};
     const motions=[
      ...outgoing.map(element=>element.animate([{transform:'translateX(0)'},{transform:'translateX(100%)'}],timing)),
      ...[photos[index],panels[index]].map(element=>element.animate([{transform:'translateX(-100%)'},{transform:'translateX(0)'}],timing))
     ];
     this.slideMotions=motions;
     this.slideReady=Promise.all(motions.map(motion=>motion.finished.catch(()=>{}))).then(()=>{
      if(current!==revision)return;
      outgoing.forEach(element=>{element.hidden=true;});
      motions.forEach(motion=>motion.cancel());
     });
     return;
    }
    if(!reduced.matches){
     this.motion=photos[index].animate(refined?[{opacity:.55},{opacity:1}]:[{opacity:.4,transform:'scale(1.025)'},{opacity:1,transform:'scale(1)'}],{duration:350,easing:'ease-out'});
     if(refined)this.noteMotion=panels[index].querySelector('.koko-ready__note').animate([{opacity:0,transform:'translateY(10px)'},{opacity:1,transform:'translateY(0)'}],{duration:380,easing:'cubic-bezier(.22,1,.36,1)'});
    }
    const product=panels[index].querySelector('.koko-ready__product, .koko-ready__texture');
    if(product&&!reduced.matches){
     this.textureReady=product.decode().catch(()=>{}).then(()=>{
      if(current!==revision||signal.aborted||reduced.matches)return;
      this.productMotion=product.animate([
       {opacity:0,transform:refined?'translateY(8px) scale(.94)':'translate(65px, 22px) rotate(12deg) scale(.92)'},
       {opacity:1,transform:'translate(0, 0) rotate(0deg) scale(1)'}
      ],{duration:refined?450:620,easing:'cubic-bezier(.16,1,.3,1)'});
      return this.productMotion.finished.catch(()=>{});
     });
    }
   };
   tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(i),{signal});tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(i+1)%tabs.length;if(event.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();activate(next);tabs[next].focus();}},{signal});});
   this.addEventListener('shopify:block:select',event=>{const index=panels.indexOf(event.target.closest('[role=tabpanel]'));if(index>=0)activate(index);},{signal});
   reduced.addEventListener('change',()=>{this.motion?.cancel();this.productMotion?.cancel();this.noteMotion?.cancel();this.slideMotions?.forEach(motion=>motion.cancel());},{signal});
   mobile.addEventListener('change',()=>{this.slideMotions?.forEach(motion=>motion.cancel());},{signal});
  }
  disconnectedCallback(){this.abort?.abort();this.preload?.disconnect();this.motion?.cancel();this.productMotion?.cancel();this.noteMotion?.cancel();this.slideMotions?.forEach(motion=>motion.cancel());}
 });
}
